import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const Contact = () => {

  const [menuOpen, setMenuOpen] = useState(false);

  const [formData, setFormData] = useState({
    name: '', email: '', subject: '', phone: '', message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch("/api/contact.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (data.success) {
      setSubmitted(true);
      setFormData({
        name: "",
        email: "",
        subject: "",
        phone: "",
        message: "",
      });
    } else {
      alert("Failed to send message");
    }
  } catch (err) {
    console.error(err);
    alert("Something went wrong");
  }
};

  const contactCards = [
    {
      icon: 'fas fa-map-marker-alt',
      title: 'Visit Our Office',
      lines: ['No.1204, 12th floor, Manjeera Trinity Corporate, JNTU-Hitech City Road , Hyderabad, Telangana - 500072.'],
    },
    {
      icon: 'fas fa-comments',
      title: "Let's Talk",
      lines: ['Phone: (+91) 9490 32 1234', ''],
    },
    {
      icon: 'fas fa-envelope',
      title: 'E-mail Us',
      lines: ['info@sourceerp.in', ''],
    },
  ];

  return (
    <div className="main-wrapper">
      <Navbar transparent />
      <PageTitle title="Contact Us" />

      {/* ===== CONTACT CARDS ===== */}
      <section className="bg-grey">
        <div className="container">
          <div className="row mt-n4">
            {contactCards.map((card, idx) => (
              <div className="col-lg-4 mt-4" key={idx}>
                <div className="card card-style07 py-2-8 px-1-6 bg-white">
                  <div className="card-body">
                    <div className="title-box mb-4">
                      <i className={card.icon}></i>
                      <div className="box-circle-large"></div>
                      <div className="box-circle-small"></div>
                    </div>
                    <h3 className="h5 mb-3">{card.title}</h3>
                    {card.lines.map((line, i) => (
                      <p className="mb-0 w-90 w-md-75 w-lg-100 mx-auto" key={i}>{line}</p>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== WHY CONTACT US ===== 
      <div className="row text-center mb-5">
        <div className="col-md-4 mb-4">
          <div className="p-3">
            <i className="fas fa-user-tie text-primary mb-2"></i>
            <h6>Certified ERP Experts</h6>
            <p className="small mb-0">Work directly with experienced Dynamics 365 consultants.</p>
          </div>
        </div>

        <div className="col-md-4 mb-4">
          <div className="p-3">
            <i className="fas fa-clock text-primary mb-2"></i>
            <h6>Quick Response</h6>
            <p className="small mb-0">We typically respond within one business day.</p>
          </div>
        </div>

        <div className="col-md-4 mb-4">
          <div className="p-3">
            <i className="fas fa-handshake text-primary mb-2"></i>
            <h6>Consultative Approach</h6>
            <p className="small mb-0">We focus on understanding your business first.</p>
          </div>
        </div>
      </div>*/}

      {/* ===== CONTACT FORM ===== */}
      <section>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="w-md-85 w-xl-65 text-center mx-auto mb-6 mb-lg-8">
                <h2 className="mb-4">Talk to Our Dynamics 365 Experts</h2>
                <p className="mx-auto mb-0">
                  Have questions about Dynamics 365 or planning an ERP
                  implementation? Our consultants are ready to understand your
                  requirements and recommend the right solution for your business.
                </p>
              </div>

              {submitted ? (
                <div className="text-center py-5">
                  <div style={{ fontSize: '60px', color: '#4CAF50', marginBottom: '20px' }}>✓</div>
                  <h3 className="mb-3">Thank You!</h3>
                  <p className="text-muted">Your message has been sent successfully. We'll get back to you shortly.</p>
                  <button
                    className="butn mt-3"
                    onClick={() => { setSubmitted(false); setFormData({ name: '', email: '', subject: '', phone: '', message: '' }); }}
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="quform-element form-group">
                        <label htmlFor="name">Your Name <span className="quform-required">*</span></label>
                        <div className="quform-input">
                          <input
                            className="form-control"
                            id="name"
                            type="text"
                            name="name"
                            placeholder="Your name here"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="quform-element form-group">
                        <label htmlFor="email">Your Email <span className="quform-required">*</span></label>
                        <div className="quform-input">
                          <input
                            className="form-control"
                            id="email"
                            type="email"
                            name="email"
                            placeholder="Your email here"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="quform-element form-group">
                        <label htmlFor="subject">Your Subject <span className="quform-required">*</span></label>
                        <div className="quform-input">
                          <input
                            className="form-control"
                            id="subject"
                            type="text"
                            name="subject"
                            placeholder="Your subject here"
                            value={formData.subject}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="quform-element form-group">
                        <label htmlFor="phone">Contact Number</label>
                        <div className="quform-input">
                          <input
                            className="form-control"
                            id="phone"
                            type="tel"
                            name="phone"
                            placeholder="Your phone number"
                            value={formData.phone}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="quform-element form-group">
                        <label htmlFor="message">Message <span className="quform-required">*</span></label>
                        <div className="quform-input">
                          <textarea
                            className="form-control"
                            id="message"
                            name="message"
                            rows="4"
                            placeholder="Briefly describe your requirement"
                            value={formData.message}
                            onChange={handleChange}
                            required
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="quform-submit-inner">
                        <button className="butn style-one fill" type="submit">
                          <span>Submit Message</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
